(()=>{'use strict';
const el=document.getElementById('MaliandioItalyGeoSettings'),form=document.getElementById('MaliandioItalyGeoForm');
if(!el||!form||window.Shopify?.designMode)return;
let cfg;try{cfg=JSON.parse(el.textContent)}catch{return}
const manual='maliandio_geo_manual_country_v2',manualLang='maliandio_manual_locale_v1',attempt='maliandio_geo_attempt_v2';
const get=(s,k)=>{try{return s.getItem(k)}catch{return null}};
const set=(s,k,v)=>{try{s.setItem(k,v)}catch{}};
document.addEventListener('click',e=>{
const item=e.target.closest?.('localization-form a[data-value],form[action*="/localization"] button[type=submit]');
if(!item||item.closest('#MaliandioItalyGeoForm'))return;
const parent=item.closest('form,localization-form');
if(parent?.querySelector('input[name=country_code]'))set(localStorage,manual,'1');
if(parent?.querySelector('input[name=locale_code],input[name=language_code]'))set(localStorage,manualLang,'1');
},true);
document.addEventListener('change',e=>{
const s=e.target;if(!s.matches?.('localization-form select'))return;
if(s.name==='country_code')set(localStorage,manual,'1');
if(s.name==='locale_code'||s.name==='language_code')set(localStorage,manualLang,'1');
},true);
if(get(localStorage,manual)||get(sessionStorage,attempt))return;
if(/(?:preview_theme_id|_ab|pb)=/.test(location.search))return;
set(sessionStorage,attempt,'1');
fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=false',{credentials:'same-origin',headers:{Accept:'application/json'}})
.then(r=>{if(!r.ok)throw Error('lookup');return r.json()})
.then(data=>{
const detected=String(data?.detected_values?.country?.handle||'').toUpperCase();
if(!detected||!/^[A-Z]{2}$/.test(detected))return;
const current=String(cfg.country||'').toUpperCase();
const locale=cfg.language||'en';
const shouldSetCountry=detected!==current;
const shouldSetItalian=detected==='IT'&&locale!=='it'&&!get(localStorage,manualLang)&&!/^(\/it)(\/|$)/i.test(location.pathname);
if(!shouldSetCountry&&!shouldSetItalian)return;
if(shouldSetCountry)form.querySelector('input[name=country_code]').value=detected;
if(shouldSetItalian)form.querySelector('input[name=language_code]').value='it';
else form.querySelector('input[name=language_code]').value=locale;
HTMLFormElement.prototype.submit.call(form);
}).catch(()=>{});
})();